import { render, staticRenderFns } from "./PayRangeDraftActionBar.vue?vue&type=template&id=18a8dc70&scoped=true"
import script from "./PayRangeDraftActionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeDraftActionBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeDraftActionBar.vue?vue&type=style&index=0&id=18a8dc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8dc70",
  null
  
)

export default component.exports